// Analytics tracking utility
// Replace G-XXXXXXXXXX in index.html with your actual Google Analytics 4 ID

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, eventParams);
  }
};

// Predefined events for Doe platform
export const analytics = {
  // User registration
  trackSignUp: (userId: string) => {
    trackEvent("sign_up", {
      method: "lumi_auth",
      user_id: userId
    });
  },

  // Donor profile creation
  trackDonorRegistration: (bloodType: string, city: string, state: string) => {
    trackEvent("cadastro_doador", {
      blood_type: bloodType,
      city: city,
      state: state
    });
  },

  // Request creation
  trackRequestCreation: (bloodType: string, urgency: string, city: string, isAnonymous: boolean) => {
    trackEvent("criar_solicitacao", {
      blood_type: bloodType,
      urgency: urgency,
      city: city,
      is_anonymous: isAnonymous
    });
  },

  // Donation confirmation
  trackDonationConfirmation: (bloodType: string, points: number, totalDonations: number) => {
    trackEvent("confirmar_doacao", {
      blood_type: bloodType,
      points_earned: points,
      total_donations: totalDonations
    });
  },

  // Share events
  trackShare: (platform: string, bloodType: string, urgency: string) => {
    trackEvent("compartilhamento", {
      platform: platform,
      blood_type: bloodType,
      urgency: urgency
    });
  },

  // Page views
  trackPageView: (pageName: string) => {
    trackEvent("page_view", {
      page_title: pageName
    });
  },

  // Blog article read
  trackBlogRead: (articleTitle: string) => {
    trackEvent("blog_read", {
      article_title: articleTitle
    });
  },

  // Hemocenter search
  trackHemocenterSearch: (city: string, state: string) => {
    trackEvent("busca_hemocentro", {
      city: city,
      state: state
    });
  },

  // Geolocation usage
  trackGeolocationUsed: (success: boolean) => {
    trackEvent("geolocation_used", {
      success: success
    });
  },

  // PWA install
  trackPWAInstall: () => {
    trackEvent("pwa_install", {
      platform: navigator.userAgent
    });
  },

  // Support donation
  trackSupportDonation: () => {
    trackEvent("apoio_projeto", {
      method: "mercado_pago"
    });
  },

  // Referral system
  trackReferralClick: (referralCode: string) => {
    trackEvent("referral_click", {
      referral_code: referralCode
    });
  },

  trackReferralSignup: (referredBy: string, newUserId: string) => {
    trackEvent("referral_signup", {
      referred_by: referredBy,
      new_user_id: newUserId
    });
  },

  trackReferralShare: (referralCode: string, platform: string) => {
    trackEvent("referral_share", {
      referral_code: referralCode,
      platform: platform
    });
  }
};
